import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.configuration-profiles')
  .factory('$agentConfigurationProfiles', AgentConfigurationProfilesObjectFactory);

/* @ngInject */
function AgentConfigurationProfilesObjectFactory($bringozFactory: $bringozFactory,
                                                 AgentConfigurationProfilesAPI: BringozApi,
                                                 AgentConfigurationProfiles_DS: DataStoreConfig) {
  function $agentConfigurationProfiles(id: string) {
    return $bringozFactory(id, AgentConfigurationProfilesAPI, AgentConfigurationProfiles_DS)
  }

  return $agentConfigurationProfiles;
}
